import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';
import { LocalNotifications } from '@capacitor/local-notifications';

/**
 * Ensure the Android notification channels used by the Customer App exist.
 * Safe to call repeatedly — Android dedupes by channel id. No-op on iOS/web.
 */
export async function ensureAdminAlertsChannel() {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'android') return;

  const channels = [
    { id: 'default', name: 'Ride updates', description: 'Booking and trip notifications' },
    { id: 'trip-offers', name: 'Trip updates', description: 'Booking lifecycle and trip status updates' },
    { id: 'admin-alerts', name: 'Important alerts', description: 'Important alerts and updates' },
  ];

  for (const ch of channels) {
    try {
      await PushNotifications.createChannel({
        id: ch.id,
        name: ch.name,
        description: ch.description,
        importance: 5,
        visibility: 1,
        sound: 'default',
        lights: true,
        vibration: true,
      });
    } catch (e) {
      console.warn('[push] createChannel failed', ch.id, e);
    }
    try {
      await LocalNotifications.createChannel({
        id: ch.id,
        name: ch.name,
        description: ch.description,
        importance: 5,
        visibility: 1,
        sound: undefined,
        lights: true,
        vibration: true,
      });
    } catch { /* ignore */ }
  }
}
